import React from 'react';

import { StyledLink } from './InlineHyperlinkStyles';

/**
 * Render inline link in rich text
 *
 * @param {Boolean} noFollow
 * @param {String} title
 * @param {String} url
 *
 * @returns {React.ReactElement}
 */
function InlineHyperlink({ title, url, noFollow }) {
  const isPhoneNumber = url.match(/^(tel:)?\d+/);

  if (isPhoneNumber) {
    const phoneNumberUrl = url.startsWith('tel:') ? url : `tel:${url}`;

    return (
      <span>
        <StyledLink url={phoneNumberUrl} rel={null} target={null} underline="always">
          {title}
        </StyledLink>
      </span>
    );
  }

  let path;
  const isInternal =
    (typeof window !== 'undefined' && (url.includes(window.location.host) || /^\/(?!\/)/.test(url))) || false;
  if (isInternal) {
    const link = new URL(url, window.location.origin);
    path = link.pathname;
  }

  return (
    <span>
      <StyledLink url={!isInternal ? url : path} external={!isInternal} noFollow={noFollow} underline="always">
        {title}
      </StyledLink>
    </span>
  );
}

export default InlineHyperlink;
